const twoFactorAuthFR = {
    "view": {
        "title": "Authentification à deux facteurs",
        "form": {
            "label": {
                "currentMethod": "Méthode d'authentification à deux facteurs actuelle",
                "authenticatorSetupTitle": "Configurez votre application d'authentification",
                "scanInstructions": "Scannez le code QR ci-dessous en utilisant n'importe quelle application d'authentification TOTP (comme Authy, Google Authenticator, Microsoft Authenticator, etc.).",
                "qrCodeAlt": "Code QR pour la configuration de l'authentificateur",
                "step1": "Ouvrez votre application d'authentification.",
                "step2": "Sélectionnez l'option pour ajouter un nouveau compte.",
                "step3": "Choisissez l'option \"Scanner un code QR\" dans l'application.",
                "step4": "Pointez l'appareil photo de votre téléphone vers le code QR ci-dessus.",
                "step5": "Une fois scanné, l'authentificateur commencera à générer un code OTP à 6 chiffres qui se rafraîchit toutes les 30 secondes. Ce code OTP peut être utilisé pour compléter le processus de connexion.",
                "appLinks": "Voici les liens pour certaines applications d'authentification courantes :",
                "appLinksAuthy": "Authy",
                "appLinksGoogle": "Google Authenticator",
                "appLinksMicrosoft": "Microsoft Authenticator",
                "googlePlay": "Google Play Store",
                "appStore": "Apple App Store",
                "loadingQrCode": "Chargement du code QR...",
                "emailSetupTitle": "Authentification à deux facteurs par email",
                "emailDescription": "Vous recevrez un mot de passe à usage unique (OTP) sur votre adresse email enregistrée, qui peut être utilisé pour compléter le processus de connexion. Assurez-vous de vérifier votre boîte de réception ou votre dossier spam pour l'OTP lors de la connexion."
            },
            "help_text": {
                "currentMethod": "L'email est actuellement défini comme méthode par défaut pour l'authentification à deux facteurs. Cependant, nous recommandons d'utiliser la méthode de l'authentificateur pour une sécurité renforcée."
            },
            "option": {
                "2faMethod": {
                    "selectMethod": "Sélectionnez la méthode 2FA",
                    "email": "Email",
                    "auth": "Authentificateur"
                }
            },
            "button": {
                "save": "Enregistrer",
                "saving": "Enregistrement..."
            }
        },
        "backupCodes": {
            "title": "Codes de secours",
            "view": {
                "button": {
                    "generate": "Générer des codes de secours",
                    "download": "Télécharger les codes de secours"
                },
                "modal": {
                    "header": "Vos codes de secours",
                    "body": {
                        "noCodes": "Aucun code de secours disponible"
                    }
                }
            }
        }
    }
};

export default twoFactorAuthFR;